import $ from "jquery";


function dropDownMenu()
{
  const optionMenu = document.querySelector(".select-menu-2"),
    selectBtn = optionMenu.querySelector(".select-btn-2"),
    options = optionMenu.querySelectorAll(".option-2"),
    sBtn_text = optionMenu.querySelector(".sBtn-text-2");

  selectBtn.addEventListener("click", () =>
    optionMenu.classList.toggle("active")
  );

  options.forEach((option) => {

    if (option.classList.contains('active')) {
      sBtn_text.innerText = option.querySelector('.option-text-2').textContent;
    }

    option.addEventListener("click", (e) => {
      e.preventDefault();

      const repayentFrequency = e.currentTarget.getAttribute("data-value");
      $(".js-repayment-frequency-2").val(parseInt(repayentFrequency));

      let selectedOption = option.querySelector(".option-text-2").innerText;
      sBtn_text.innerText = selectedOption;

      $(".mortgage-frequency-text-2").text(selectedOption);

      optionMenu.classList.remove("active")
      pay_off_more = void 0;

      setTimeout((function() {
        return calculate()
      }), 100);
    });
  });
}

function events()
{

  $(document).on("keyup", ".js-number-input-2", (function(e) {
    if ("" === window.getSelection().toString() && -1 === $.inArray(e.keyCode, [38, 40, 37, 39])) {
        var term,
          element = $(this), 
          value = element.val();

        element.hasClass("js-mortgage-interest-rate-2") || element.hasClass("js-loan-term-2") ? (term = value.replace(/[^0-9.]|\.(?=.*\.)/g, ""),
        element.hasClass("js-loan-term-2") && term > 30 && (term = 30)) : term = (term = value.replace(/[\D\s\._\-]+/g, "")) ? parseInt(term, 10) : 0,
        element.val((function() {
            return 0 === term ? 0 : term.toLocaleString("en-US")
        }))
    }
  }));

  $(document).on("change", ".js-mortgage-loan-amount-2,.js-mortgage-interest-rate-2", (function(e) {
    e.preventDefault(),
    setTimeout((function() {
      return calculate()
    }), 110);
  }));

}

function calculate()
{

  const loanAmount = parseInt($(".js-mortgage-loan-amount-2").val().replace(/,/g, ""));
  const annualInterestRate = parseFloat($('.js-mortgage-interest-rate-2').val()); // Annual interest rate in percentage
  const weeksInYear = parseInt($('.js-repayment-frequency-2').val()); // Number of weeks in a year

  // Calculate the weekly interest rate
  const weeklyInterestRate = (annualInterestRate / 100) / weeksInYear;

  // Round the result to four decimal places
  const roundedWeeklyInterestRate = weeklyInterestRate;

  const interestPayment = loanAmount * roundedWeeklyInterestRate;

  // Display the result
  let totalRepayments = new countUp.CountUp("js-your-mortgage-repayments-interest-text", interestPayment.toFixed(0), {
    decimalPlaces: 0,
    duration: 1
  });
  totalRepayments.start();

}

window.addEventListener('load', function(event) {
  if ($(".select-btn-2").length){
    /* DROPDOWN */
    dropDownMenu();

    /* EVENTS */
    events();

    calculate();
  }
  
});